import { render } from "./basic-setting.vue?vue&type=template&id=7991ebac&scoped=true&ts=true"
import script from "./basic-setting.vue?vue&type=script&lang=ts"
export * from "./basic-setting.vue?vue&type=script&lang=ts"

import "./basic-setting.vue?vue&type=style&index=0&id=7991ebac&scoped=true&lang=less"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7991ebac"]])

export default __exports__